import cookies from 'react-cookies';
import moment from 'moment';
import 'moment/locale/ru';
import 'moment/locale/ro';

moment.locale(cookies.load('localization') || 'ro');

export default moment;
